export const BE_BASE_URL: string = (process.env.REACT_APP_BE_BASE_URL as string) || '';
export const SEZIONE_AVIS: string = (process.env.REACT_APP_SEZIONE_AVIS as string) || '';
